import { Button, Chip,  CircularProgress,  Grid, MenuItem, TextField, Typography } from "@mui/material"
import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import { getUserName } from "../../services/user.service";
import { useEffect, useMemo, useState } from "react";
import { createJiraTicket, getJiraStatus, loadJiraProjects, loadJiraStatuses, loadJiraUsers, updateJiraTicket, updateTestResult } from "../../services/jira.service";
import { CHANNELS } from "../../types/global.enum";
import { useAppDispatch } from "../../store/hooks";
import { globalNotification, toggleAlert } from "../../store/resuders/app.reducer";

export const JiraTicket = ({
    testResultDetails = null as any,
    project = null as any,
    cancel = null as any,
    channel = null as CHANNELS | null,
    scheduled = '',

})=> {
    const { t } = useTranslation();
    const [users,setUsers] = useState<any[]>([]);
    const [loading,isLoading] = useState<boolean>(true);
    const [projects, setProjects] = useState<any[]>([]);
    const [statuses, setStatus] = useState<any[]>([]);
    const dispatch = useAppDispatch();
    const url = useMemo(()=> `${document.location.protocol}//${document.location.host}/projects/${project?.testProjectID}${scheduled ? '/scheduled':''}/testresults/${scheduled || testResultDetails?.testCaseId || testResultDetails?.id}/${testResultDetails?.testResult?.id}` ,[testResultDetails, project]);

    const formik = useFormik({
        initialValues: {
            labels:'',
            tags:[],
            summary:'',
            assignee:'',
            project:'',
            status:'',
        },
        onSubmit: async (values: any) => {
            let body = {
                project: values?.project,
                summary: values.summary,
                issueType: "Bug",
                assignee: values.assignee,
                labels: values.tags || [],
                username: getUserName(),
                description: url,
                } as any;

            if(editMode) {
                body = {
                    ...body,
                    status: values.status,
                };

                const result:any = await updateJiraTicket(testResultDetails?.testResult?.jiraTicket, body).catch(e => e);

                if (["ERR_BAD_RESPONSE", "ERR_BAD_REQUEST","fail"].includes(result?.code)) {
                    dispatch(toggleAlert(result?.response?.data?.data?.messages?.join(',')))
                    return;
                }
                dispatch(globalNotification('Ticket has been Updated.'));

                cancel && cancel(true);
               
                return;
            }

            const jira = await createJiraTicket(body).catch(e => e);

                if (["ERR_BAD_RESPONSE", "ERR_BAD_REQUEST","fail"].includes(jira?.code)) {
                    dispatch(toggleAlert(jira?.response?.data?.data?.messages?.join(',')))
                    return;
                }

              if(jira?.key) {
                await updateTestResult(testResultDetails?.testResult?.id, jira?.key, channel);
              }
              dispatch(globalNotification('Ticket has been Created.'))
              cancel && cancel(true);
        }
    })

    const handleAddLable = (e:any)=> {
        if (e.key === "Enter"){
            formik.setFieldValue('tags',[...(formik.values.tags || []), formik.values?.labels]);
            formik.setFieldValue('labels','');
        }
    }

    const saveChanges = async ()=> {
        await formik.submitForm();
    }

    const handleDelete = (tag:string)=>()=> {
        formik.setFieldValue('tags',formik.values.tags.filter(c=>c!==tag));
    }

    const editMode = useMemo(()=>testResultDetails?.testResult?.jiraTicket,[testResultDetails?.testResult?.jiraTicket]);

    
    useEffect(()=> {
        const loadUsers = async()=> {
            
            const data = await loadJiraUsers();
            setUsers(data);

            const projects= await loadJiraProjects();
            setProjects(projects)

            const statuses= await loadJiraStatuses();
            setStatus(statuses)

            if(editMode) {

                const status = await getJiraStatus(testResultDetails?.testResult?.jiraTicket);

                formik.setValues({
                    labels:'',
                    tags:status?.labels,
                    summary:status?.summary,
                    assignee:status?.assigneeId,
                    project:status?.project,
                    status:status?.status,
                });
                
            }
            isLoading(false);
        }
        
        loadUsers();
    },[editMode])
    
    return (
        <>
        {loading && <div className="data-loader"><CircularProgress /> <span>&nbsp;&nbsp;&nbsp;&nbsp;Please wait ...</span></div>}

        <Grid container spacing={3} sx={{mt:3,pl:3}}>
            <Grid item xs={8} >
                <TextField label={t('Test Case Name')} disabled={true} value={testResultDetails?.name} fullWidth />
            </Grid>
            <Grid item xs={4} sx={{pr:3}}>
                <TextField label={t('Test Case ID')} disabled={true} value={testResultDetails?.testCaseId} fullWidth/>
            </Grid>
            <Grid item xs={8} >
                <TextField label={t('URL to Test Result')} disabled={true} fullWidth 
                            value={url}/>
            </Grid>
            <Grid item xs={4} sx={{pr:3}}>
                <TextField label={t('Test Result ID')} disabled={true} fullWidth value={testResultDetails?.testResult?.id}/>
            </Grid>
            <Grid item xs={12} className="jira-details-header bg-light-green" sx={{mt:2}}>
                <Typography>{t('Jira Ticket Details')}</Typography>
            </Grid>
            <Grid item xs={4}  className="bg-light-green">
                 <TextField label={t('Assignee *')}  InputLabelProps={{shrink: true,}} select fullWidth onChange={formik.handleChange}  value={formik.values.assignee} name="assignee" id="assignee">
                    {users.map(user=>(
                        <MenuItem value={user.accountId}  key={user.accountId}>{user.name}</MenuItem>
                    ))}
                </TextField>
            </Grid>
            <Grid item xs={4}  className="bg-light-green">
                <TextField label={t('Project *')}  InputLabelProps={{shrink: true,}} select fullWidth onChange={formik.handleChange}  value={formik.values.project} name="project" id="project">
                {projects.map(project=>(
                        <MenuItem value={project.key}  key={project.key}>{project.name}</MenuItem>
                    ))}
                </TextField>
            </Grid>
            {formik.values.tags?.length>2 && <Grid item xs={4} className="bg-light-green"></Grid> }
            <Grid item xs={formik.values.tags?.length>2 ? 12:4}  className="bg-light-green tags" sx={{pr:3}}>
                {formik.values.tags?.map((tag:string)=>(
                    <Chip label={tag} onDelete={handleDelete(tag)}/>
                ))}
                <TextField label={t('Labels')}     InputLabelProps={{shrink: true,}} placeholder={t('Type here and hit Enter')}  fullWidth onChange={formik.handleChange} name="labels" id="labels" value={formik.values.labels} 
                onKeyDown={handleAddLable}/>
            </Grid>
            <Grid item xs={12}  className="bg-light-green" sx={{pr:3,pb:3}} >
                <TextField label={t('Summary *')}     InputLabelProps={{
            shrink: true,
          }} fullWidth value={formik.values.summary} onChange={formik.handleChange} id="summary" name="summary" />
            </Grid>

            {editMode && 
            <>
                <Grid item xs={4} className="bg-light-green">
                     <TextField label={t('Status')}  InputLabelProps={{shrink: true,}} select fullWidth onChange={formik.handleChange}  value={formik.values.status} name="status" id="status">
                        {statuses.map(status=>(
                                <MenuItem value={status.name}  key={status.name}>{status.name}</MenuItem>
                            ))}
                        </TextField>
                </Grid>
                 <Grid item xs={8} className="bg-light-green" /> </>
            }
            <Grid item xs={12}  className="bg-light-green" sx={{pr:3,pb:3,pt:2}} style={{display:'flex',gap:'40px',justifyContent:'center'}}>
                    <Button variant='contained' onClick={cancel}>
                        <Typography >{t('Cancel')}</Typography>
                    </Button>

                    <Button variant='contained' onClick={saveChanges}>
                        <Typography >{t(editMode ? 'Save Changes':'Confirm')}</Typography>
                    </Button>
            </Grid>
        </Grid>
        </>
    )
}